import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import TVWeeklyStatusGrid from './TVWeeklyStatusGrid';
import TVStationOverlayShell from './TVStationOverlayShell';
import { getTvSpotConfig } from '../../data/tvSpotLocation';
import tvBroadcast from './tvBroadcastStyles';
import tvTheme from './tvTheme';

/**
 * previousWeek / nextWeek 共通
 * 街の写真を背景に、地点×曜日の表＋下部テロップ1本
 */
function TVWeeklySummaryPanel({ data, compact = false, loading = false }) {
  if (!data) {
    return (
      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography sx={{ fontWeight: 800, color: tvTheme.colors.textDark }}>
          {loading ? '読込中…' : 'データがありません'}
        </Typography>
      </Box>
    );
  }

  const {
    panelTitle,
    kindLabel,
    periodLabel,
    generatedAtLabel,
    locations,
    insufficientData,
    summary,
    imageSrc,
  } = data;

  const bgSrc = imageSrc || getTvSpotConfig('station').imageSrc;
  const titleMeta = [periodLabel, generatedAtLabel ? `更新 ${generatedAtLabel}` : '']
    .filter(Boolean)
    .join(' ／ ');

  return (
    <Box sx={{ ...tvBroadcast.root, opacity: loading ? 0.5 : 1 }}>
      <TVStationOverlayShell
        imageSrc={bgSrc}
        title={panelTitle}
        titleMeta={titleMeta}
        caption={insufficientData ? null : summary}
        captionLabel={insufficientData ? null : kindLabel}
        compact={compact}
        airy
        contentMaxWidth={compact ? '100%' : 'min(96%, 1120px)'}
      >
        {insufficientData ? (
          <Typography
            sx={{
              fontSize: compact ? '1.05rem' : 'clamp(1.6rem, 3vw, 2.4rem)',
              fontWeight: 900,
              color: tvTheme.colors.textDark,
              textAlign: 'center',
              bgcolor: 'rgba(255,255,255,0.92)',
              border: '3px solid #fff',
              borderRadius: 1,
              px: compact ? 1 : 2,
              py: compact ? 0.8 : 1.5,
            }}
          >
            この期間のデータを十分に確認できませんでした
          </Typography>
        ) : (
          <TVWeeklyStatusGrid locations={locations} compact={compact} />
        )}
      </TVStationOverlayShell>
    </Box>
  );
}

TVWeeklySummaryPanel.propTypes = {
  data: PropTypes.shape({
    panelTitle: PropTypes.string,
    kindLabel: PropTypes.string,
    dataKind: PropTypes.oneOf(['actual', 'forecast']),
    periodLabel: PropTypes.string,
    generatedAtLabel: PropTypes.string,
    locations: PropTypes.array,
    insufficientData: PropTypes.bool,
    summary: PropTypes.string,
    imageSrc: PropTypes.string,
  }),
  compact: PropTypes.bool,
  loading: PropTypes.bool,
};

export default TVWeeklySummaryPanel;
